import React from 'react';
import './Download.css';

const Download: React.FC = () => {
  return (
    <section className="download" id="download">
      <div className="download__bg-blob download__bg-blob--blue" />
      <div className="download__bg-blob download__bg-blob--green" />

      <div className="container">
        <div className="download__inner">
          <div className="download__content">
            <span className="section-label">Get the App</span>
            <h2 className="section-title">
              Start your journey<br /><span>today — it's free</span>
            </h2>
            <p className="section-subtitle">
              Download FitMind AI and get your personalised training and nutrition plan
              in under 3 minutes. No gym required to get started.
            </p>

            <div className="download__stores">
              <a href="https://play.google.com/store/apps/details?id=com.mumetech.fitmindai" target="_blank" rel="noopener noreferrer" className="download__store-btn download__store-btn--main">
                <svg className="download__store-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3.18 23.76c.37.2.8.2 1.18 0l11.46-6.62-2.5-2.5L3.18 23.76zm16.46-10.26c.42-.24.67-.68.67-1.15v-.7c0-.47-.25-.91-.67-1.15L16.69 8.9l-2.8 2.8 2.8 2.8 2.95-1zM4.36.24C3.98.04 3.55.04 3.18.24L13.32 10.4 15.82 7.9 4.36.24zM2.01 1.04C1.76 1.34 1.6 1.72 1.6 2.12v19.75c0 .4.16.78.41 1.08l.06.06L13.3 11.78v-.28L2.01 1.04z"/>
                </svg>
                <div>
                  <div className="download__store-sub">Get it on</div>
                  <div className="download__store-name">Google Play</div>
                </div>
              </a>
            </div>

            <div className="download__android-note">
              <span>📱</span> Available on Android
            </div>

            <div className="download__perks">
              <div className="download__perk">
                <span className="download__perk-icon">🎁</span>
                Free to download
              </div>
              <div className="download__perk">
                <span className="download__perk-icon">⚡</span>
                Plan ready in 3 min
              </div>
              <div className="download__perk">
                <span className="download__perk-icon">🔒</span>
                No credit card needed
              </div>
            </div>
          </div>

          <div className="download__phones">
            <div className="download__phone download__phone--back">
              <div className="download__phone-notch" />
              <video
                src="/assets/videos2/nutrition_screen_video_v2.webm"
                autoPlay
                loop
                muted
                playsInline
              />
            </div>
            <div className="download__phone download__phone--front">
              <div className="download__phone-notch" />
              <img src="/assets/images2/home_screen.png" alt="Home screen" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Download;
